<template>
    <div class="overflow-hidden">
        <div class="row no-gutters">
            <!-- Sidebar -->
            <div class="col-sm-12" v-if="CalendarDetails.legend">
                <b-card class="mx-2">
                    <b-card-title class="mb-1"> Legend </b-card-title>
                    <b-card-body>
                        <b-badge v-for="(item, index) in CalendarDetails.legend" :key="index" :variant="item.variant"
                            class="mr-1">{{ item.name }}</b-badge>
                    </b-card-body>
                </b-card>
            </div>

            <!-- Calendar -->
            <div class="col-sm-12 position-relative">
                <div class="card shadow-none border-0 mb-0 rounded-0">
                    <div class="card-body pb-0">
                        <FullCalendar :options="calendarOptions" />
                    </div>
                </div>
            </div>
            <b-sidebar id="sidebar-right" bg-variant="white" right title="View Job Card" backdrop shadow
            :visible="showSidebar" ref="sidebar">
            <b-button  size="sm" class="mt-1 w-100" @click="goToPage(selectedItem)">
                    View
                </b-button>
          </b-sidebar>
            <!-- Sidebar Overlay -->
        </div>
    </div>
</template>

<script>
// Full Calendar Plugins
import {
    BButton,
    BSidebar,
    BCard,
    BCardTitle,
    BBadge,
    BCardBody,
    BFormSelect,
    BRow,
    BCol,
} from "bootstrap-vue";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import Sidebar from "./SidebarView.vue";
import { mapGetters, mapActions } from "vuex";

export default {
    components: {
        FullCalendar,
        BButton,
        BSidebar,
        Sidebar,
        BBadge,
        BCardBody,
        BCard,
        BCardTitle,
        BFormSelect,
        BRow,
        BCol,
    },
    props: {
        CalendarDetails: {
            type: Object,
            default: () => {
                return {
                    viewSidebar: false,
                    legend: [],
                    events: [{}]
                }
            },
        }
    },
    data() {
        return {
            calendarOptions: {
                plugins: [dayGridPlugin, timeGridPlugin],
                initialView: 'dayGridMonth',
                events: this.CalendarDetails.events,
                editable: true,
                selectable: true,
                eventClick: this.handleEventClick,
            },
            showSidebar: this.CalendarDetails.viewSidebar,
            selectedItem: {},
        };
    },
    computed: {

    },
    setup(props) {
    },
    mounted() {
        this.calendarOptions.events = this.CalendarDetails.events;
    },
    methods: {
        handleEventClick(clickInfo) {
            window.open(clickInfo.event._def.extendedProps.link, "_blank");
        },
    },
     goToPage(selectedItem) {
    this.$router.push('/jobcard/view/' + selectedItem.id); 
  }, 
    handleEventClick(clickInfo) {
        this.showSidebar = !this.showSidebar;
        this.selectedItem = clickInfo.event;
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>

<style scoped>
.fc .fc-daygrid-event-harness .fc-event {
    font-size: 1.06rem;
}
</style>
